export function resolvePriorCapRecognition(input) {
    const cap = input.framework.caps.find((c) => c.code === input.capCode);
    const prerequisiteCapCode = input.framework.caps.find((c) => c.id === cap?.prerequisiteCapId)?.code;
    if (!prerequisiteCapCode)
        return { recognized: false, reason: 'cap_has_no_prerequisite' };
    if (!input.stacksOnProgramId)
        return { recognized: false, prerequisiteCapCode, reason: 'no_prior_program' };
    // MISMO NIVEL a propósito: un certificado de pregrado no sostiene un diploma de
    // posgrado apilado sobre él, y el marco fija mínimos por nivel.
    const certification = input.certifications.find((c) => c.programId === input.stacksOnProgramId &&
        c.capCode === prerequisiteCapCode &&
        c.level === input.level &&
        c.status === 'granted');
    if (!certification)
        return {
            recognized: false,
            priorProgramId: input.stacksOnProgramId,
            prerequisiteCapCode,
            reason: 'not_certified',
        };
    return {
        recognized: true,
        priorProgramId: input.stacksOnProgramId,
        prerequisiteCapCode,
        certificationId: certification.id,
        grantedAt: certification.grantedAt,
    };
}
//# sourceMappingURL=cap-prior-recognition.service.js.map